<template>
  <div class="generic">
    <div class="fullwidth narex">
      <div class="right-padding">
        <editable-item :page="pageName" item="text" :loaded="loaded" />
      </div>
    </div>
  </div>
</template>

<script>
import EditableItem from '@/components/editors/EditableItem.vue'

export default {
  components: {
    EditableItem
  },
  data () {
    return {
      pageName: '',
      text: '',
      loaded: false
    }
  },
  created () {
    this.loaded = false
    this.init()
  },
  methods: {
    init: function () {
      this.pageName = this.$route.name
      this.loadData()
    },
    loadData: async function () {
      console.log('called load data for ' + this.pageName)
      this.$k.fetchStories(this.pageName, () => {
        console.log('call succeded ' + this.pageName)
        this.loaded = true
      })
    },
  },
  watch: {
    '$route.path': function () {
      console.log('route changed')
      this.loaded = false
      this.init()
    }
  }
}
</script>

<style scoped>
.right-padding{
  padding-right:40%;
}

@media screen and (max-width:1100px){
  .right-padding{
    padding-right:0;
  }
}
</style>
